// extracted by mini-css-extract-plugin
export default {"btn-primary":"PrimaryButton_btn-primary__33OI6"};